import clsx from 'clsx';
import React from 'react';

type SectionHeaderProps = {
  collapse?: boolean;
} & React.ComponentPropsWithoutRef<'div'>;

export function SectionHeader({ collapse = false, className, ...props }: SectionHeaderProps) {
  return (
    <div
      className={clsx(
        className,
        'flex justify-between mb-2',
        collapse ? 'flex-col sm:flex-row gap-8 mb-4 sm:mb-0' : 'flex-row'
      )}
      {...props}
    />
  );
}
